import React from "react";

const UserProfileSvg = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        {/* Blue gradient similar to the PNG */}
        <linearGradient id="bgGradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#0A5ED7"/>
          <stop offset="100%" stopColor="#4EC3FF"/>
        </linearGradient>

        {/* Soft shadow for user shape */}
        <filter id="softShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="4" stdDeviation="6" floodColor="#000" floodOpacity="0.15"/>
        </filter>
      </defs>

      {/* Blue circular background - fills entire viewBox */}
      <circle
        cx="128"
        cy="128"
        r="128"
        fill="url(#bgGradient)"
      />

      {/* User head - larger */}
      <circle
        cx="128"
        cy="100"
        r="38"
        fill="#FFFFFF"
        filter="url(#softShadow)"
      />

      {/* User body - larger */}
      <path
        d="M56 180
           C56 140, 200 140, 200 180
           V200
           H56
           Z"
        fill="#FFFFFF"
        filter="url(#softShadow)"
      />
    </svg>
  );
};

export default UserProfileSvg;
